import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import findByString from "../../../../../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import {Tab, Tabs, Tooltip} from "@material-ui/core";
import ColorPickerPopover from "../../../../../../../../../Utils/ColorPickerPopover";

const HoverColorPicker = ({label, path, setValue, values}) => {
    const [activeTab, setActiveTab] = useState(0)
    const [hoverPath, setHoverPath] = useState(path)
    function onChangeTab(v) {
        setActiveTab(v)
    }
    useEffect(() => {
        let splitPath = path.split('.');
        let name = splitPath[splitPath.length - 1];
        let joined = splitPath.slice(0, splitPath.length - 1).join('.') + '.' + 'hoverStyles' + '.' + name;
        setHoverPath(joined)
    }, [path])
    function completeColor(color, name, path) {
        setValue(color, path)
    }
    const currentColor = findByString(values, path);
    const currentHoverColor = findByString(values, hoverPath);

    return (
        <div style={{marginTop: 5}}>
            <div>
                <div style={{width: 105}}>
                    {label}
                </div>
                <Tabs
                    value={activeTab}
                    onChange={(e, v) => onChangeTab(v)}
                    variant={"standard"}
                    indicatorColor={"primary"}
                    style={{minHeight: 30}}
                >
                    <Tab label={'Normal'} value={0} style={{minHeight: 30, padding: 0}}/>
                    <Tab label={'Hover'} value={1} style={{minHeight: 30, padding: 0}}/>
                </Tabs>
                {activeTab === 0 && (
                    <ColorPick
                        currentColor={currentColor}
                        completeColor={completeColor}
                        path={path}
                        type={'normal'}
                    />
                )}
                {activeTab === 1 && (
                    <ColorPick
                        currentColor={currentHoverColor}
                        completeColor={completeColor}
                        path={hoverPath}
                        type={'hover'}
                    />
                )}
            </div>
        </div>
    );
};

HoverColorPicker.propTypes = {
    label: PropTypes.string,
    path: PropTypes.string,
    setValue: PropTypes.func,
    values: PropTypes.object
};

export default HoverColorPicker;

const ColorPick = ({currentColor, completeColor, path}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    function onClick(e) {
        setAnchorEl(e.currentTarget)
    }
    return(
        <div style={{display: 'flex', margin: '5px 0 10px 0'}}>
            <div style={{
                marginTop: 5,
                width: '100%',
                padding: '5px',
                background: '#fff',
                borderRadius: '1px',
                boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                display: 'inline-block',
                cursor: 'pointer',
            }}
                 onClick={onClick}
            >
                <Tooltip title={"Select Color"}>
                    <div style={{
                        borderRadius: '2px',
                        height: '14px',
                        background: currentColor || 'rgba(0,0,0,1)'
                    }}/>
                </Tooltip>
            </div>
            <ColorPickerPopover
                open={Boolean(anchorEl)}
                path={path}
                color={currentColor}
                close={() => setAnchorEl(null)}
                complete={completeColor}
                anchorEl={anchorEl}
                type={"sketch"}
            />
        </div>
    )

}
